"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var vizportalclient_common_components_1 = require("@tableau/vizportalclient-common-components");
var widgets_1 = require("@tableau/widgets");
var Localize_1 = require("../../gen-src/Localize");
var ColumnAndFieldDetailsStyles_1 = require("./style/ColumnAndFieldDetailsStyles");
exports.maxCharacterLength = 4000;
exports.inlineDescriptionEditTestId = 'description-text-area';
exports.inlineDescriptionViewTestId = 'inline-description-view';
var InlineDescriptionTableCell = data_catalog_shared_1.divWithStyle('InlineDescriptionTableCell', {
    display: 'table-cell',
});
var TextAreaWidgetDivWrapperStyle = vizportalclient_common_components_1.cssClass('textAreaWidgetDivWrapperStyle', {
    width: '100%'
});
function InlineDescriptionEditor_Edit(props) {
    var markupEditingEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).markupEditingEnabled;
    var _a = props.editModeLogic, isActionBusy = _a.isActionBusy, editorState = _a.editorState, setEditorStateWithinEditMode = _a.setEditorStateWithinEditMode;
    var _b = widgets_1.getMaxCharValidation(editorState.potentialDescription, exports.maxCharacterLength), message = _b.message, valid = _b.valid;
    return (React.createElement(InlineDescriptionTableCell, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsTextAreaWrapper, null, markupEditingEnabled ?
            React.createElement(widgets_1.TextFormatterWidget, { label: null, disabled: isActionBusy, markup: editorState.potentialDescription, onChange: function (event) { return setEditorStateWithinEditMode({ potentialDescription: event.target.value }); }, previewClassName: data_catalog_shared_1.MarkupTooltipStyleClass, style: ColumnAndFieldDetailsStyles_1.columnDetailsTextAreaStyle, valid: valid, testId: exports.inlineDescriptionEditTestId, message: message }) :
            React.createElement(widgets_1.TextAreaWidget, { label: null, disabled: isActionBusy, value: editorState.potentialDescription, onChange: function (event) { return setEditorStateWithinEditMode({ potentialDescription: event.target.value }); }, className: TextAreaWidgetDivWrapperStyle, style: ColumnAndFieldDetailsStyles_1.columnDetailsTextAreaStyle, valid: valid, testId: exports.inlineDescriptionEditTestId, message: message })),
        React.createElement(ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsWrapper, null,
            React.createElement(SaveAndCancelButtonsFlexWrapper, null,
                React.createElement("div", { style: { marginRight: widgets_1.TabStyles.Spacing.MediumSpace } },
                    React.createElement(vizportalclient_common_components_1.InlineEditorCancelButton, __assign({}, props.editModeLogic))),
                React.createElement("div", null,
                    React.createElement(vizportalclient_common_components_1.InlineEditorSaveButton, __assign({}, props.editModeLogic)))))));
}
var DivToRemoveSomePaddingOnThePTag = data_catalog_shared_1.divWithStyle('divToRemoveSomePaddingOnThePTag', {
    $nest: {
        p: {
            marginTop: 0,
            marginBottom: widgets_1.TabStyles.Spacing.SmallSpace
        }
    }
});
function InlineDescriptionEditor_View(props) {
    var markupEditingEnabled = React.useContext(data_catalog_shared_1.FeatureFlagsContext).markupEditingEnabled;
    var readModeLogic = props.readModeLogic, description = props.description;
    return (React.createElement(React.Fragment, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsDescriptionValue, null,
            React.createElement("div", { style: { maxHeight: ColumnAndFieldDetailsStyles_1.descriptionMaxHeight } }, description ? (markupEditingEnabled ?
                React.createElement(DivToRemoveSomePaddingOnThePTag, null,
                    React.createElement(data_catalog_shared_1.FormattedMarkupWrapperInTooltip, { markup: description, testId: exports.inlineDescriptionViewTestId })) :
                React.createElement(NonFormattedMarkupWrapper, { description: description })) :
                React.createElement(ColumnAndFieldDetailsStyles_1.ColumnDetailsPlaceholder, null, Localize_1.Messages.NoDescriptionAvailable()))),
        React.createElement(vizportalclient_common_components_1.InlineEditorEditButton, __assign({}, readModeLogic, { editButtonLabel: Localize_1.Messages.EditDescription() }))));
}
function NonFormattedMarkupWrapper(props) {
    return (React.createElement("div", { "data-tb-test-id": exports.inlineDescriptionViewTestId }, props.description));
}
exports.NonFormattedMarkupWrapper = NonFormattedMarkupWrapper;
function InlineDescriptionEditor(props) {
    var _this = this;
    var _a = React.useState(props.initialDescription.substring(0, exports.maxCharacterLength)), description = _a[0], setDescription = _a[1];
    var onSave = React.useCallback(function (editorState) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, props.onSave(editorState.potentialDescription)];
                case 1:
                    _a.sent();
                    setDescription(editorState.potentialDescription);
                    if (!props.afterSave) return [3 /*break*/, 3];
                    return [4 /*yield*/, vizportalclient_common_components_1.delayPromise(2000)];
                case 2:
                    _a.sent(); // when this was a class component this used to be window.setTimeout(props.afterSave, 2000);
                    props.afterSave();
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [props.onSave, props.afterSave]);
    var logic = vizportalclient_common_components_1.useInlineEditor({
        editorStateWhenEnteringEditMode: { potentialDescription: description },
        canEdit: props.canEdit,
        onSave: onSave,
        exitEditModeOnFailedSave: true,
        canSaveFn: function (state) {
            return state.potentialDescription.length <= exports.maxCharacterLength &&
                state.potentialDescription !== props.initialDescription;
        }
    });
    return (React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsProperty, null,
        React.createElement(ColumnAndFieldDetailsStyles_1.ColumnAndFieldDetailsLabel, null, Localize_1.Messages.Description()),
        vizportalclient_common_components_1.isEditMode(logic) ?
            React.createElement(InlineDescriptionEditor_Edit, { editModeLogic: logic }) :
            React.createElement(InlineDescriptionEditor_View, { readModeLogic: logic, description: description })));
}
exports.InlineDescriptionEditor = InlineDescriptionEditor;
var SaveAndCancelButtonsFlexWrapper = data_catalog_shared_1.divWithStyle('SaveAndCancelButtonsFlexWrapper', __assign({}, ColumnAndFieldDetailsStyles_1.SaveAndCancelButtonsFlexWrapperSharedStyle));
//# sourceMappingURL=InlineDescriptionEditor.js.map